import type React from "react"

export const Displays = (props: React.ComponentProps<"svg">): JSX.Element => (
    <svg width='24' height='24' fill='none' {...props}>
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M2 5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5V15C22 16.6569 20.6569 18 19 18H15.5308L15.903 19.4888L16.7071 20.2929C16.9931 20.5789 17.0787 21.009 16.9239 21.3827C16.7691 21.7564 16.4045 22 16 22H8C7.59554 22 7.2309 21.7564 7.07612 21.3827C6.92134 21.009 7.0069 20.5789 7.29289 20.2929L8.09704 19.4888L8.46922 18H5C3.34315 18 2 16.6569 2 15V5ZM4 14V15C4 15.5523 4.44772 16 5 16H9.72757C9.74198 15.9997 9.75643 15.9997 9.77092 16H14.2291C14.2436 15.9997 14.258 15.9997 14.2724 16H19C19.5523 16 20 15.5523 20 15V14H4ZM20 12H4V5C4 4.44772 4.44772 4 5 4H19C19.5523 4 20 4.44772 20 5V12ZM13.4692 18H10.5308L10.0308 20H13.9692L13.4692 18Z'
            fill='currentColor'
        />
    </svg>
)
